<div class="label-container">
    <cerrix-label [for]="name"><ng-content></ng-content></cerrix-label>
    @if (infoText) {
        <cerrix-instructions-icon
            class="input-instructions-icon"
            [instructionText]="infoText"
            [showText]="false"
        ></cerrix-instructions-icon>
    }
</div>
<cerrix-input
    validationErrors
    [validationMaxLength]="maxLength"
    appValidationIsUrlField
    [type]="type"
    [name]="name"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [(value)]="value"
    (valueChange)="valueChange.emit(value)"
></cerrix-input>
